export default function Spinner({ size }: { size?: 'lg' }) {
  return <span className={`spinner ${size ?? ''}`} role="status" aria-label="Carregando" />;
}

export function PageLoading() {
  return <div className="page-loading"><Spinner size="lg" /></div>;
}
